import PrivateLayoutView from "./view";

export default PrivateLayoutView;
